import axios from "axios";
import { FormEvent } from "react";
import { toast } from "react-toastify";
import { SetState } from "zustand";
import { ICarcerarioNominalstore } from "..";
import { IConsultaCarcerario } from "../../../interface/fichaCarcerario";

export interface ICarcerarioNominalModuleStore {
  resultadoCarcerarioNominal: IConsultaCarcerario[] | null;
  mensagemCarcerario?: string;
  consultaCarcerarioNominal(
    url: string,
    nome: undefined | string,
    vulgo: undefined | string,
    nomeMae: undefined | string,
    nomePai: undefined | string,
    e?: FormEvent
  ): Promise<void>;
  limparConsultaCarcerarioNominal(): void;
}

export default (set: SetState<ICarcerarioNominalstore>) =>
  ({
    resultadoCarcerarioNominal: null,
    async consultaCarcerarioNominal(url, nome, vulgo, nomeMae, nomePai, e) {
      e?.preventDefault();
      try {
        const storedToken = sessionStorage.getItem("@webSDS:token");

        set((state) => ({
          ...state,
          global: {
            ...state.global,
            loading: true,
          },
        }));

        const response = await axios.get(`${url}/carcerario`, {
          params: {
            DET_NOME: nome,
            DET_NOMEVULGO: vulgo,
            DET_NOMEMAE: nomeMae,
            DET_NOMEPAI: nomePai,
          },
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        });

        if (response.status === 200) {
          set((state) => ({
            ...state,
            global: {
              ...state.global,
              loading: false,
            },
            carcerario: {
              ...state.carcerario,
              resultadoCarcerarioNominal: response.data,
            },
          }));
        }
        if (response.status === 400) {
          toast.error(`${response.data.message}`, {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 4000,
          });
        }
        if (response.status === 401) {
          toast.error(
            "A SUA SESSÃO EXPIROU, EFETUE LOGIN NOVAMENTE PARA CONTINUAR USANDO O POLÍCIA ÁGIL.",
            {
              position: toast.POSITION.TOP_CENTER,
              autoClose: 4000,
            }
          );
          // logout()
        }
        if (response.status === 404) {
          // toast.error(`${response.data.message}`, {
          //   position: toast.POSITION.TOP_CENTER,
          //   autoClose: 4000,
          // })
          set((state) => ({
            carcerario: {
              ...state.carcerario,
              resultadoCarcerarioNominal: null,
              mensagemCarcerario: response.data.message,
            },
          }));
        }
        if (response.status === 500 || response.status === 503) {
          toast.error("ERRO NO SERVIDOR, TENTE MAIS TARDE!", {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 4000,
          });
          return;
        }
        if (response.status === 504) {
          toast.error(
            "O SERVIDOR DEMOROU MUITO PARA RESPONDER, TENTE NOVAMENTE EM INSTANTES.",
            {
              position: toast.POSITION.TOP_CENTER,
              autoClose: 4000,
            }
          );
          return;
        }
      } catch (error) {
        toast.error("ERRO DE CONEXÃO! VERIFIQUE SUA INTERNET!", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 4000,
        });
      } finally {
        set((state) => ({
          ...state,
          global: {
            ...state.global,
            loading: false,
          },
        }));
      }
    },
    limparConsultaCarcerarioNominal() {
      set((state) => ({
        ...state,
        carcerario: {
          ...state.carcerario,
          resultadoCarcerarioNominal: null,
          mensagemCarcerario: undefined,
        },
      }));
    },
  } as ICarcerarioNominalModuleStore);
